import React, { useState, useEffect } from 'react'
import CurrencyInput from './CurrencyInput'
import Slider from 'rc-slider'
import { sanitizeHTML } from '../../../../shared/utils/common-utils'

export default function WithdrawalRateSlider(props) {
  let leftDocumentContent = ''
  let rightDocumentContent = ''

  if (props && props.contentLeft) {
    leftDocumentContent = props.contentLeft
  }
  if (props && props.contentRight) {
    rightDocumentContent = props.contentRight
  }
  const initialState = {
    assetValue: '',
    withdrawalRate: 5,
    inflationAdjustment: false,
  }
  const [state, setState] = useState(() => {
    const savedState = localStorage.getItem(`WithdrawalRateSlider`)
    return savedState ? JSON.parse(savedState) : initialState
  })

  const [withdrawalAmount, setWithdrawalAmount] = useState('')

  // Both arrays give the probability of income lasting at 4-9% withdrawals.
  // The first array’s data adjusts for inflation; the second’s does not.
  const incomeLastingData = [
    [91, 67, 39, 16, 4, 1],
    [99, 94, 79, 55, 31, 13],
  ]

  const estimateWithdrawalAmount = (rate, totalValue) => {
    let unformattedResult = (totalValue * rate) / 100
    return unformattedResult
  }

  const handleInflationAdjustment = () => {
    handleStateChange('inflationAdjustment', !state.inflationAdjustment)
  }

  const handleSliderChange = value => {
    handleStateChange('withdrawalRate', value)
  }

  const parseProbability = (inflationAdjustment, withdrawalRate) => {
    let arrayNumber = 0
    if (inflationAdjustment) {
      arrayNumber = 0
    } else {
      arrayNumber = 1
    }
    return incomeLastingData[arrayNumber][withdrawalRate - 4]
  }

  useEffect(() => {
    localStorage.setItem(`WithdrawalRateSlider`, JSON.stringify(state))
  }, [state])

  const handleStateChange = (name, value) => {
    setState(prev => ({ ...prev, [name]: value }))
  }

  useEffect(() => {
    const currencyFormatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0,
    })

    const assetNumber = Number(state.assetValue)
    const withdrawalAmount = estimateWithdrawalAmount(state.withdrawalRate, assetNumber)
    const formattedWithdrawalAmount = currencyFormatter.format(withdrawalAmount)
    setWithdrawalAmount(formattedWithdrawalAmount)

    let slider = document.querySelector('.rc-slider-handle')
    slider.innerHTML = `<div class="slider-percentage-display u-textCenter u-textColorWhite u-textPrimary u-textBold u-textSizeMsrp1 u-paddingTop3gu" data-analytics="RIG-ensuring-lifestyle-slider">${state.withdrawalRate}%</div>`
  }, [state.assetValue, state.withdrawalRate])

  return (
    <div className='withdrawal-rate-wrap u-marginTop10gu u-bgColorLight u-sizeFull'>
      <div className='withdrawal-rate-content withdrawal-rate-copy-section u-sizeConstrained u-flex u-bgColorWhite u-flexJustifyBetween'>
        <div className='think-carefully u-size1of2 u-pt-sizeFull u-paddingTop12gu'>
          {leftDocumentContent && (
            <>
              <div
                className='u-textColorBrand u-paddingTop8gu u-marginBottom5gu'
                dangerouslySetInnerHTML={{
                  __html: sanitizeHTML(leftDocumentContent),
                }}></div>
            </>
          )}
          <div className='withdrawal-rate-slider-inputs u-marginBottom6gu print-flex-wrap'>
            <label
              htmlFor='total-asset-value'
              className='u-textSizeMsrp1 u-pt-size4of4 u-marginBottom3gu u-pt-marginBottom0 u-textColorBrand Form-label'>
              Total asset value<span className='pt-inline'>:</span>
            </label>
            <div className='u-pt-size4of4 u-pt-marginBottom3gu'>
              <CurrencyInput
                id='total-asset-value'
                name='total-asset-value'
                value={state.assetValue}
                valueChanged={value => handleStateChange('assetValue', value)}
              />
            </div>

            <div className='Checkbox Checkbox--large'>
              <input
                className='Checkbox-button Checkbox--large'
                id='inflation-adjustment'
                name='name-large'
                type='checkbox'
                defaultChecked={state.inflationAdjustment}
                onChange={handleInflationAdjustment}
                value='1'
              />
              <label
                htmlFor='inflation-adjustment'
                className='Checkbox-label'
                data-analytics='RIG-adjust-for-inflation-checkbox'>
                Adjust for inflation
                <sup>
                  <a href='/ensuring-lifestyle#footnote-double-asterisk'>**</a>
                </sup>
              </label>
            </div>
          </div>
        </div>
        <div className='factors-that-can-reduce  u-size1of2 withdrawal-rate-card-wrap u-pt-sizeFull u-paddingTop12gu'>
          <div className='withdrawal-rate-card u-marginLeft11gu u-paddingHoriz6gu u-paddingVert7gu u-flex u-flexWrap'>
            {rightDocumentContent && (
              <>
                <div
                  dangerouslySetInnerHTML={{
                    __html: sanitizeHTML(rightDocumentContent),
                  }}></div>
              </>
            )}
          </div>
        </div>
      </div>
      <div className='withdrawal-rate-content withdrawal-slider-probability-section print-force-background u-bgColorWhite u-paddingBottom15gu u-paddingTop15gu u-sizeConstrained u-flex u-flexJustifyBetween u-flexWrap'>
        <div className='pt-slider-padding u-sizeFull u-lg-size2of3'>
          <h4 className='u-textCenter u-textSecondary u-textBold u-textSizeMsrp2 u-textColorBrand u-marginBottom6gu'>
            Estimated Withdrawal Rate
          </h4>
          <div
            className='withdrawal-rate-tooltip u-size1of3 u-bgColorDarkMint u-marginBottom12gu u-padding2gu'
            // We can calcuate how much to move the slider using
            // * the # of stops (5)
            // * the slider position (state.withdrawalRate)
            // * and the relative width of the slider (66%)

            style={{
              marginLeft: `${(66.66 / 5) * (state.withdrawalRate - 4)}%`,
            }}>
            {/*
            currencyFormatter will return '$NaN' when it receives non-numeric input
            Handle this case to avoid displaying '$NaN'
            */}

            <p className='u-textCenter u-textColorWhite u-textSizeMsrp3 u-marginVert2gu u-textSecondary'>
              {withdrawalAmount === ('' || '$NaN') ? '$0' : withdrawalAmount}
            </p>
            <svg
              width='69'
              height='33'
              viewBox='0 0 69 33'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'>
              <path d='M34.2857 33L68.3081 0.857147H0.263287L34.2857 33Z' fill='#007886' />
            </svg>
          </div>
          <div className='u-sizeFull'>
            <div className='withdrawal-rate-slider-wrapper u-size2of3'>
              <Slider
                min={4}
                max={9}
                step={1}
                value={state.withdrawalRate}
                onChange={handleSliderChange}
                trackStyle={[
                  {
                    height: 6,
                    marginTop: -6,
                  },
                ]}
                railStyle={{
                  height: 30,
                  marginTop: -15,
                }}
                handleStyle={[
                  {
                    opacity: 1,
                    border: 'none',
                    height: 45,
                    width: 45,
                    marginTop: -24,
                  },
                ]}
                dotStyle={{
                  border: 'none',
                  height: 20,
                  width: 20,
                }}
                dots
              />
            </div>
          </div>
          <div className='u-sizeFull u-paddingTop7gu u-marginBottom8gu'>
            <div className='pt-slider-labels u-size2of3 u-flex u-flexJustifyBetween u-marginCenter'>
              <div className='pt-reduced u-textSizeMsr u-textBold u-textPrimary u-textColorAdele'>
                Reduced withdrawals
              </div>
              <div className='pt-increased u-textSizeMsr u-textBold u-textPrimary u-textColorAdele'>
                Increased withdrawals
              </div>
            </div>
          </div>
        </div>

        <div className='u-sizeFull u-lg-size1of3'>
          <div className='u-size2of3 probability-copy u-marginCenter'>
            <h4 className='u-textCenter u-textSizeMsrp2 u-textSecondary u-textBold u-textColorBrand u-marginBottom4gu'>
              Probability of Income Lasting
              <sup>
                <a href='/ensuring-lifestyle#footnote-double-asterisk'>**</a>
              </sup>
            </h4>
            <p className='probability-result u-textCenter u-textColorAdele u-textSecondary u-textSizeMsrp10'>
              {parseProbability(state.inflationAdjustment, state.withdrawalRate)}%
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
